// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__rBoxx","box":"style_box__+kJa8","active":"style_active__fbrZx","title":"style_title__jCLIR","item":"style_item__izcpY"};